/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a coding sequence above to see its codon usage.`)
};

const es_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia codificante arriba para ver su uso de codones.`)
};

const de_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie oben eine Kodierungssequenz ein, um ihre Codon-Nutzung zu sehen.`)
};

const nl_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven een coderende sequentie om het codongebruik te zien.`)
};

const fr_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence codante ci-dessus pour voir son usage des codons.`)
};

const it_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza codificante sopra per vedere il suo uso dei codoni.`)
};

const pt_br2_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante acima para ver seu uso de códons.`)
};

const pt_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante acima para ver o seu uso de codões.`)
};

const ja_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上にコード配列を貼り付けるとコドン使用頻度が表示されます。`)
};

const zh_codon_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴编码序列以查看其密码子使用情况。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_hint_empty", locale)
	if (locale === "en") return en_codon_hint_empty(inputs)
	if (locale === "es") return es_codon_hint_empty(inputs)
	if (locale === "de") return de_codon_hint_empty(inputs)
	if (locale === "nl") return nl_codon_hint_empty(inputs)
	if (locale === "fr") return fr_codon_hint_empty(inputs)
	if (locale === "it") return it_codon_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_codon_hint_empty(inputs)
	if (locale === "pt") return pt_codon_hint_empty(inputs)
	if (locale === "ja") return ja_codon_hint_empty(inputs)
	return zh_codon_hint_empty(inputs)
};